import { render, staticRenderFns } from "./form-search.vue?vue&type=template&id=71a2b508&"
import script from "./form-search.vue?vue&type=script&lang=js&"
export * from "./form-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports